export default __webpack_public_path__ + "static/1-ed9455f90489dec02defdcd87b6fe381.webp";